var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    staticClass: "background w-100 p-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "m-0",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "p-0",
    attrs: {
      "cols": "5"
    }
  }, [_vm._t("form-template")], 2), _c('b-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('div', {
    staticClass: "signup-image-container"
  }, [_c('img', {
    staticClass: "w-75",
    attrs: {
      "src": require("@/assets/images/signup/signup_picture.png"),
      "alt": "Cascade signup picture"
    }
  })])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }